export const YY_MM = 'YYYY-MM';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const YYYY_MM_DD_HH_MM_SS = 'YYYY-MM-DD HH:mm:ss';
export const DD_MM_YYYY = 'DD/MM/YYYY';
export const MMMM_YYYY = 'MMMM, YYYY';
export const MM_YYYY = 'MM/YYYY';
export const MM_YYYY_DOTS = 'MM.YYYY';
export const DD_MM_YYYY_HH_MM_SS = 'DD/MM/YYYY HH:mm:ss';
export const DD_MM_YYYY_HH_MM_SS_SSS = 'DD/MM/YYYY HH:mm:ss.SSS';
export const YYYY = 'YYYY';
